export default 
[
  {
      "featureType": "landscape",
      "elementType": "all",
      "stylers": [
          {
              "hue": "#FFBB00"
          },
          {
              "lightness": 37.599999999999994
          },
          {
              "gamma": 1
          }
      ]
  },
  {
      "featureType": "poi",
      "elementType": "all",
      "stylers": [
          {
              "hue": "#00FF6A"
          },
          {
              "saturation": -49
          },
          {
              "lightness": 28
          },
          {
              "gamma": 1
          }
      ]
  },
  {
      "featureType": "road.highway",
      "elementType": "all",
      "stylers": [
          {
              "hue": "#ffa500"
          },
          {
              "saturation": "-46"
          },
          {
              "lightness": "29"
          },
          {
              "gamma": "0.71"
          }
      ]
  },
  {
      "featureType": "road.highway",
      "elementType": "geometry.fill",
      "stylers": [
          {
              "lightness": "54"
          }
      ]
  },
  {
      "featureType": "road.highway",
      "elementType": "labels.icon",
      "stylers": [
          {
              "lightness": "13"
          },
          {
              "gamma": "0.67"
          },
          {
              "saturation": "-87"
          }
      ]
  },
  {
      "featureType": "road.arterial",
      "elementType": "all",
      "stylers": [
          {
              "hue": "#FF0300"
          },
          {
              "saturation": -100
          },
          {
              "lightness": 51.19999999999999
          },
          {
              "gamma": 1
          }
      ]
  },
  {
      "featureType": "road.local",
      "elementType": "all",
      "stylers": [
          {
              "hue": "#ff0300"
          }
      ]
  },
  {
      "featureType": "water",
      "elementType": "all",
      "stylers": [
          {
              "hue": "#0078FF"
          },
          {
              "saturation": -13.200000000000003
          },
          {
              "lightness": 2.4000000000000057
          },
          {
              "gamma": 1
          }
      ]
  }
]
;